/** Fallback attribute values for known characters when API omits extended fields. */
const CHARACTER_ATTRIBUTE_FALLBACKS = {
	nia: {
		occupation: 'Lifeguard trainer',
		relationship: 'Single',
		ethnicity: 'Australian',
		origin: 'Australia',
		zodiac: 'Sagittarius',
		body_type: 'Athletic',
		kinks: ['Teasing', 'Praise'],
	},
	luna: {
		occupation: 'Astrologer',
		relationship: 'Single',
		ethnicity: 'Spanish',
		origin: 'Spain',
		zodiac: 'Pisces',
		body_type: 'Elegant',
		kinks: ['Slow burn', 'Roleplay'],
	},
	cleo: {
		occupation: 'Archaeologist',
		relationship: 'Single',
		ethnicity: 'Egyptian',
		origin: 'Egypt',
		zodiac: 'Leo',
		body_type: 'Elegant',
		kinks: ['Dominant', 'Teasing'],
	},
	elise: {
		occupation: 'Luxury consultant',
		relationship: 'Single',
		ethnicity: 'French',
		origin: 'France',
		zodiac: 'Taurus',
		body_type: 'Elegant',
		kinks: ['Praise', 'Slow burn'],
	},
	monique: {
		occupation: 'Casino dealer',
		relationship: 'Single',
		ethnicity: 'American',
		origin: 'USA',
		zodiac: 'Scorpio',
		body_type: 'Elegant',
		kinks: ['Dominant', 'Voyeur'],
	},
	martina: {
		occupation: 'Tennis player',
		relationship: 'Single',
		ethnicity: 'Italian',
		origin: 'Italy',
		zodiac: 'Aries',
		body_type: 'Athletic',
		kinks: ['Teasing'],
	},
	hana: {
		occupation: 'Pilot',
		relationship: 'Single',
		ethnicity: 'Japanese',
		origin: 'Japan',
		zodiac: 'Virgo',
		body_type: 'Athletic',
		kinks: ['Teasing'],
	},
	zoe: {
		occupation: 'DJ',
		relationship: 'Single',
		ethnicity: 'Korean',
		origin: 'Korea',
		zodiac: 'Gemini',
		body_type: 'Fit',
		kinks: ['Teasing'],
	},
	mika: {
		occupation: 'Night muse',
		relationship: 'Single',
		ethnicity: 'Canadian',
		origin: 'Canada',
		zodiac: 'Cancer',
		body_type: 'Elegant',
		kinks: ['Teasing'],
	},
	sasha: {
		occupation: 'Luxury host',
		relationship: 'Single',
		ethnicity: 'German',
		origin: 'Germany',
		zodiac: 'Capricorn',
		body_type: 'Elegant',
		kinks: ['Teasing'],
	},
	alex: {
		occupation: 'Trainer',
		relationship: 'Single',
		ethnicity: 'American',
		origin: 'USA',
		zodiac: 'Libra',
		body_type: 'Athletic',
		kinks: ['Teasing'],
	},
	dorian: {
		occupation: 'Mentor',
		relationship: 'Single',
		ethnicity: 'British',
		origin: 'United Kingdom',
		zodiac: 'Aquarius',
		body_type: 'Fit',
		kinks: ['Teasing'],
	},
	ewka: {
		occupation: 'Fitness trainer',
		relationship: 'Single',
		ethnicity: 'Polish',
		origin: 'Sanok',
		zodiac: 'Libra',
		body_type: 'Athletic',
		kinks: ['Teasing', 'Praise'],
	},
	orion: {
		occupation: 'Mythology nerd',
		relationship: 'Single',
		ethnicity: 'Icelandic',
		origin: 'Iceland',
		zodiac: 'Aquarius',
		body_type: 'Fit',
		kinks: ['Teasing'],
	},
};

export const getCharacterAttributeFallback = (profile) => {
	const key = profile?.name?.trim().toLowerCase();

	if (!key) {
		return null;
	}

	return CHARACTER_ATTRIBUTE_FALLBACKS[key] || null;
};
